import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"

import Sidebar from "./Sidebar"


import "../styles/product-card.css"
// import { useEffect, useRef } from "preact/hooks"


export default function Products() {
    const {
        response: { products },
        loading
    } = useAppState()
    // const productGridRef = useRef(null);

    // useEffect(()=>{
    //     if(!productGridRef.current) return;

    //     const handleGridClick = (e) => {
    //         const button = e.target.closest('.ns-input');
    //         const skuId = button?.getAttribute('nosto-sku');
    //         const productId = button?.getAttribute('nosto-id');
    
    //         if(!productId || button.classList.contains('ns-disabled')) return;
    
    //         Nosto.addSkuToCart({ productId, skuId },"nosto-search")
    //         .then(() => theme.addItem())
    //         .catch(err => console.error(err))
    //     }

    //     productGridRef.current.addEventListener('click', handleGridClick);
    //     return () => productGridRef.current.removeEventListener('click', handleGridClick);
    // }, []);


    return (
        <div 
            id="nosto-product-grid"
            class="collection page-width" 
            style={loading ? "opacity: 0.3;" : ""} 
            // ref={productGridRef}
        >
            <Sidebar/>
            <ul class="grid grid--2-col grid--3-col-tablet grid--one-third-max grid--4-col-desktop grid--quarter-max negative-margin">
                {products.hits.map((hit, index) => {
                    return <Product product={hit} key={hit.productId || index} />
                })}
            </ul>
        </div>
    )
}
